import { StorageType } from "src/utils/dataSource.helper";

export interface StorageAction {
  id: string;
  name: string;
  storageType: StorageType;
  image: string;
}

export interface ToolbarButton {
  id: string;
  image: string;
  onClick: () => void;
  name: string;
}

export interface ToolbarProps {
  buttons: ToolbarButton[];
  className?: string;
}

export interface MigrationProgress {
  migratedAssets: number;
  percentage: number;
  completed: boolean;
  hasUpdates?: boolean;
  initialTotalAssets: number; 
  toastFired?: boolean;
}

export interface ProgressBarProps {
  percent: number;
  segmentWidth?: number;
}

export interface DataSource {
  id: string;
  name: string;
  storageName: string;
  storageType: string;
  migrationStatus: string;
  syncStatus: string;
  assets: number;
  streams: number;
  createdDate: number;
  modifiedDate: number;
  lastMigrationDate: number;
  workspace: string | null;
  workspaceName: string | null;
}

export interface StorageUsage {
  datasourceFilesLimit: number;
  datasourceFilesUsed: number;
  assetStorageLimit: number;
  assetStorageUsed: number;
}

export enum StorageTrackerType {
  PAPERFLITE = "Paperflite",
  CONTENT_SOURCE = "Content Source",
}